import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  New: "bg-amtm-give/20 text-amtm-giveText border-amtm-give/40",
  "Under Care": "bg-amtm-info/15 text-amtm-info border-amtm-info/30",
  Released: "bg-amtm-success/15 text-amtm-success border-amtm-success/30",
  Adopted: "bg-amtm-success/15 text-amtm-success border-amtm-success/30",
  "Sanctuary Resident": "bg-amtm-teal/15 text-amtm-teal border-amtm-teal/30",
  "Passed Away": "bg-amtm-textMuted/15 text-amtm-textMuted border-amtm-textMuted/30",
};

export default function StatusBadge({ status, className }) {
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border",
        STATUS_STYLES[status] || "bg-muted text-muted-foreground border-border",
        className
      )}
    >
      {status}
    </span>
  );
}
